export default __webpack_public_path__ + "static/media/profit-bg.3615af06.png";